import { useOutletContext } from 'react-router-dom'

import { ExportTrainingsDataDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { TrainingEmployeesDataTable } from 'modules/trainings/components/Revamp/TrainingsDetail/TrainingEmployeesDataTable'

import { DetailOutletContext } from '../types'

const Participants = () => {
  const { classes, training } = useOutletContext<DetailOutletContext>()
  const { data, loading, error } = useQuery(ExportTrainingsDataDocument)

  return (
    <ResponsivePage.Body showHeader={false} loading={loading} error={error}>
      <TrainingEmployeesDataTable
        training={training}
        trainingClasses={classes}
        teams={data?.teams.teams ?? []}
      />
    </ResponsivePage.Body>
  )
}

export default Participants
